import { default as _91_46_46_46slug_937VpnIGNNkBMeta } from "/builds/s-o-f/vkusilosos-frontend/pages/[...slug].vue?macro=true";
import { default as _91dish_slug_93lw3Imz25f1Meta } from "/builds/s-o-f/vkusilosos-frontend/pages/[category_slug]/[dish_slug].vue?macro=true";
import { default as indexf0GB3yI3LLMeta } from "/builds/s-o-f/vkusilosos-frontend/pages/[category_slug]/index.vue?macro=true";
import { default as indexFZizcfCrSvMeta } from "/builds/s-o-f/vkusilosos-frontend/pages/apps/index.vue?macro=true";
import { default as _91id_93SujfV1RhWRMeta } from "/builds/s-o-f/vkusilosos-frontend/pages/blog/[id].vue?macro=true";
import { default as indexpV2vAX2bL9Meta } from "/builds/s-o-f/vkusilosos-frontend/pages/blog/index.vue?macro=true";
import { default as delivery_conditionsLqNcOO6seDMeta } from "/builds/s-o-f/vkusilosos-frontend/pages/delivery_conditions.vue?macro=true";
import { default as indexKWi5t47OutMeta } from "/builds/s-o-f/vkusilosos-frontend/pages/index.vue?macro=true";
import { default as indexyHXHAjpWwrMeta } from "/builds/s-o-f/vkusilosos-frontend/pages/legal/index.vue?macro=true";
import { default as _91token_93yhOqxI65hrMeta } from "/builds/s-o-f/vkusilosos-frontend/pages/login-by-token/[token].vue?macro=true";
import { default as not_45foundnjLzFV71vxMeta } from "/builds/s-o-f/vkusilosos-frontend/pages/not-found.vue?macro=true";
import { default as _91id_93MTj3aFDFEQMeta } from "/builds/s-o-f/vkusilosos-frontend/pages/payment/status/[id].vue?macro=true";
import { default as privacy_policyeoFripVS1oMeta } from "/builds/s-o-f/vkusilosos-frontend/pages/privacy_policy.vue?macro=true";
import { default as _91id_93ftLwsW5xW2Meta } from "/builds/s-o-f/vkusilosos-frontend/pages/promotions/[id].vue?macro=true";
import { default as indexl90mjZD0ThMeta } from "/builds/s-o-f/vkusilosos-frontend/pages/promotions/index.vue?macro=true";
import { default as public_offertaL4bLzk0yM3Meta } from "/builds/s-o-f/vkusilosos-frontend/pages/public_offerta.vue?macro=true";
import { default as user_agreementexCih02uVhMeta } from "/builds/s-o-f/vkusilosos-frontend/pages/user_agreement.vue?macro=true";
import { default as component_45stubmY95CJhrnqMeta } from "/builds/s-o-f/vkusilosos-frontend/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
export default [
  {
    name: _91_46_46_46slug_937VpnIGNNkBMeta?.name ?? "slug",
    path: _91_46_46_46slug_937VpnIGNNkBMeta?.path ?? "/:slug(.*)*",
    meta: _91_46_46_46slug_937VpnIGNNkBMeta || {},
    alias: _91_46_46_46slug_937VpnIGNNkBMeta?.alias || [],
    redirect: _91_46_46_46slug_937VpnIGNNkBMeta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91dish_slug_93lw3Imz25f1Meta?.name ?? "category_slug-dish_slug",
    path: _91dish_slug_93lw3Imz25f1Meta?.path ?? "/:category_slug()/:dish_slug()",
    meta: _91dish_slug_93lw3Imz25f1Meta || {},
    alias: _91dish_slug_93lw3Imz25f1Meta?.alias || [],
    redirect: _91dish_slug_93lw3Imz25f1Meta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/pages/[category_slug]/[dish_slug].vue").then(m => m.default || m)
  },
  {
    name: indexf0GB3yI3LLMeta?.name ?? "category_slug",
    path: indexf0GB3yI3LLMeta?.path ?? "/:category_slug()",
    meta: indexf0GB3yI3LLMeta || {},
    alias: indexf0GB3yI3LLMeta?.alias || [],
    redirect: indexf0GB3yI3LLMeta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/pages/[category_slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexFZizcfCrSvMeta?.name ?? "apps",
    path: indexFZizcfCrSvMeta?.path ?? "/apps",
    meta: indexFZizcfCrSvMeta || {},
    alias: indexFZizcfCrSvMeta?.alias || [],
    redirect: indexFZizcfCrSvMeta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/pages/apps/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93SujfV1RhWRMeta?.name ?? "blog-id",
    path: _91id_93SujfV1RhWRMeta?.path ?? "/blog/:id()",
    meta: _91id_93SujfV1RhWRMeta || {},
    alias: _91id_93SujfV1RhWRMeta?.alias || [],
    redirect: _91id_93SujfV1RhWRMeta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/pages/blog/[id].vue").then(m => m.default || m)
  },
  {
    name: indexpV2vAX2bL9Meta?.name ?? "blog",
    path: indexpV2vAX2bL9Meta?.path ?? "/blog",
    meta: indexpV2vAX2bL9Meta || {},
    alias: indexpV2vAX2bL9Meta?.alias || [],
    redirect: indexpV2vAX2bL9Meta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: delivery_conditionsLqNcOO6seDMeta?.name ?? "delivery_conditions",
    path: delivery_conditionsLqNcOO6seDMeta?.path ?? "/delivery_conditions",
    meta: delivery_conditionsLqNcOO6seDMeta || {},
    alias: delivery_conditionsLqNcOO6seDMeta?.alias || [],
    redirect: delivery_conditionsLqNcOO6seDMeta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/pages/delivery_conditions.vue").then(m => m.default || m)
  },
  {
    name: indexKWi5t47OutMeta?.name ?? "index",
    path: indexKWi5t47OutMeta?.path ?? "/",
    meta: indexKWi5t47OutMeta || {},
    alias: indexKWi5t47OutMeta?.alias || [],
    redirect: indexKWi5t47OutMeta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexyHXHAjpWwrMeta?.name ?? "legal",
    path: indexyHXHAjpWwrMeta?.path ?? "/legal",
    meta: indexyHXHAjpWwrMeta || {},
    alias: indexyHXHAjpWwrMeta?.alias || [],
    redirect: indexyHXHAjpWwrMeta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/pages/legal/index.vue").then(m => m.default || m)
  },
  {
    name: _91token_93yhOqxI65hrMeta?.name ?? "login-by-token-token",
    path: _91token_93yhOqxI65hrMeta?.path ?? "/login-by-token/:token()",
    meta: _91token_93yhOqxI65hrMeta || {},
    alias: _91token_93yhOqxI65hrMeta?.alias || [],
    redirect: _91token_93yhOqxI65hrMeta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/pages/login-by-token/[token].vue").then(m => m.default || m)
  },
  {
    name: not_45foundnjLzFV71vxMeta?.name ?? "not-found",
    path: not_45foundnjLzFV71vxMeta?.path ?? "/not-found",
    meta: not_45foundnjLzFV71vxMeta || {},
    alias: not_45foundnjLzFV71vxMeta?.alias || [],
    redirect: not_45foundnjLzFV71vxMeta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/pages/not-found.vue").then(m => m.default || m)
  },
  {
    name: _91id_93MTj3aFDFEQMeta?.name ?? "payment-status-id",
    path: _91id_93MTj3aFDFEQMeta?.path ?? "/payment/status/:id()",
    meta: _91id_93MTj3aFDFEQMeta || {},
    alias: _91id_93MTj3aFDFEQMeta?.alias || [],
    redirect: _91id_93MTj3aFDFEQMeta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/pages/payment/status/[id].vue").then(m => m.default || m)
  },
  {
    name: privacy_policyeoFripVS1oMeta?.name ?? "privacy_policy",
    path: privacy_policyeoFripVS1oMeta?.path ?? "/privacy_policy",
    meta: privacy_policyeoFripVS1oMeta || {},
    alias: privacy_policyeoFripVS1oMeta?.alias || [],
    redirect: privacy_policyeoFripVS1oMeta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/pages/privacy_policy.vue").then(m => m.default || m)
  },
  {
    name: _91id_93ftLwsW5xW2Meta?.name ?? "promotions-id",
    path: _91id_93ftLwsW5xW2Meta?.path ?? "/promotions/:id()",
    meta: _91id_93ftLwsW5xW2Meta || {},
    alias: _91id_93ftLwsW5xW2Meta?.alias || [],
    redirect: _91id_93ftLwsW5xW2Meta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/pages/promotions/[id].vue").then(m => m.default || m)
  },
  {
    name: indexl90mjZD0ThMeta?.name ?? "promotions",
    path: indexl90mjZD0ThMeta?.path ?? "/promotions",
    meta: indexl90mjZD0ThMeta || {},
    alias: indexl90mjZD0ThMeta?.alias || [],
    redirect: indexl90mjZD0ThMeta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/pages/promotions/index.vue").then(m => m.default || m)
  },
  {
    name: public_offertaL4bLzk0yM3Meta?.name ?? "public_offerta",
    path: public_offertaL4bLzk0yM3Meta?.path ?? "/public_offerta",
    meta: public_offertaL4bLzk0yM3Meta || {},
    alias: public_offertaL4bLzk0yM3Meta?.alias || [],
    redirect: public_offertaL4bLzk0yM3Meta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/pages/public_offerta.vue").then(m => m.default || m)
  },
  {
    name: user_agreementexCih02uVhMeta?.name ?? "user_agreement",
    path: user_agreementexCih02uVhMeta?.path ?? "/user_agreement",
    meta: user_agreementexCih02uVhMeta || {},
    alias: user_agreementexCih02uVhMeta?.alias || [],
    redirect: user_agreementexCih02uVhMeta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/pages/user_agreement.vue").then(m => m.default || m)
  },
  {
    name: component_45stubmY95CJhrnqMeta?.name ?? undefined,
    path: component_45stubmY95CJhrnqMeta?.path ?? "/home",
    meta: component_45stubmY95CJhrnqMeta || {},
    alias: component_45stubmY95CJhrnqMeta?.alias || [],
    redirect: component_45stubmY95CJhrnqMeta?.redirect,
    component: () => import("/builds/s-o-f/vkusilosos-frontend/node_modules/nuxt/dist/pages/runtime/component-stub").then(m => m.default || m)
  }
]